import { Component } from '../helpers/helper';

const VERIFIED_KEY = 'ga_age_verified';
const DECLINED_KEY = 'ga_age_declined';

// LTI launches arrive with an `ltik` query parameter (and follow-on requests
// keep it). When the site is embedded as an LTI tool the school/teacher is
// the consenting party under COPPA's school-authorization exception, so we
// skip the age gate entirely.
export function isLtiContext(): boolean {
	const s = window.location.search || '';
	return /[?&]lti(k|_)/i.test(s);
}

export function ageGateRequired(): boolean {
	if (isLtiContext()) return false;
	if (localStorage.getItem(VERIFIED_KEY) === 'true') return false;
	return true;
}

export function ageDeclined(): boolean {
	return localStorage.getItem(DECLINED_KEY) === 'true';
}

class AgeState {
	declined = false;
	dob = '';
	error: string = null;
}

export const AgeGateDlg = Component((p: { onAccept: () => void }) => {
	const s = Vue.reactive(new AgeState());
	s.declined = ageDeclined();

	function submit() {
		s.error = null;
		if (!s.dob) {
			s.error = 'Please enter your date of birth.';
			return;
		}
		const dob = new Date(s.dob);
		if (isNaN(dob.getTime())) {
			s.error = 'Please enter a valid date.';
			return;
		}
		const now = new Date();
		let age = now.getFullYear() - dob.getFullYear();
		const m = now.getMonth() - dob.getMonth();
		if (m < 0 || (m === 0 && now.getDate() < dob.getDate())) age--;
		if (age < 13) {
			localStorage.setItem(DECLINED_KEY, 'true');
			s.declined = true;
			return;
		}
		localStorage.setItem(VERIFIED_KEY, 'true');
		p.onAccept();
	}

	return () => (
		<div class="age-gate-overlay">
			<div class="age-gate-dlg">
				{!s.declined ? (
					<div>
						<h2>Welcome to GatherAct</h2>
						<p>
							GatherAct is a free, peer-to-peer meeting tool offered as a technology demo. The
							service is <b>not designed for, directed at, or monitored for use by children.
					        </b>. There is no human moderation of meeting rooms.
						</p>
						<p>Please confirm your date of birth to continue:</p>
						<input
							type="date"
							value={s.dob}
							onChange={e => (s.dob = (e.target as HTMLInputElement).value)}
						/>
						{s.error && <div class="age-gate-error">{s.error}</div>}
						<p class="age-gate-fine">
							By continuing you agree to our{' '}
							<a href="/terms_of_service" target="_blank">Terms of Service</a> and{' '}
							<a href="/privacy_policy" target="_blank">Privacy Policy</a>.
						</p>
						<div class="age-gate-buttons">
							<button class="button accent" onClick={submit}>Continue</button>
						</div>
					</div>
				) : (
					<div>
						<h2>You can't use this site</h2>
						<p>
							GatherAct is intended for users 13 and older. If your school uses GatherAct in
							class, your teacher can launch it for you through your learning management
							system.
						</p>
					</div>
				)}
			</div>
		</div>
	);
});
